import { RouteObject } from 'react-router-dom';
import WorkspaceComponent from './workspace-component';
import WorkspaceLandingPageComponent from './components/workspace-landing-page-component';
import WorkspaceGateShellComponent from './components/workspace-gate-shell-component';
import RecordProducerPage from 'modules/record/record-producer/pages/record-producer';
import RecordListPage from 'modules/record/record-list/pages/record-list';
import GATE_ROUTES from 'modules/gate/routers/GateRouter';
import MyWorkPage from 'modules/my-work/pages/MyWorkPage';

const WORKSPACE_ROUTES: RouteObject[] = [
    {
        path: "workspace",
        element: (
            <WorkspaceComponent />
        ),
        children: [
            {
                path: "",
                element: <WorkspaceLandingPageComponent />, //<RecordListComponent />,
            },
            {
                path: "my-work",
                element: <MyWorkPage />
            },
            {
                path: ":tableName/list",
                element: <RecordListPage />, //<RecordListComponent />,
            },
            {
                path: ":tableName/record",
                children: [
                    {
                        path: ":id",
                        element: <RecordProducerPage />
                    },
                    {
                        path: "",
                        element: <RecordProducerPage />
                    }
                ]
            },
            {
                path: "g",
                element: <WorkspaceGateShellComponent />,
                children: GATE_ROUTES
            }
        ]
    }
];

export default WORKSPACE_ROUTES;